/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_contract = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.59 3.5 8.618 1.328A1 1 0 0 0 7.878 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4m4.242-3.645-.394 3.4a.406.406 0 0 0 .215.435.42.42 0 0 0 .486-.073L11.683 14l1.135 1.117a.42.42 0 0 0 .486.073.407.407 0 0 0 .216-.436l-.4-3.42m-1.453.5c1.288 0 2.333-1.03 2.333-2.299 0-1.27-1.045-2.298-2.333-2.298-1.29 0-2.334 1.029-2.334 2.298 0 1.27 1.045 2.298 2.334 2.298Z"
    />
  </svg>
)
export default file_contract
